module.exports = __webpack_public_path__ + "assets/img/daily_task_title.a5fdd79a.png";